import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../../service/admin.service';
import * as constants from '../../app.constants';
import { NotificationsService } from 'angular2-notifications';
import { FlagTicketCount } from "../../model/flag-ticket-count";

@Component({
  selector: 'flag-ticket-treshold-count',
  template: require('./flag-ticket-treshold-count.component.html'),
  styles: [require('./flag-ticket-treshold-count.component.css')]
})

export class FlagTicketTresholdCountComponent implements OnInit, AfterViewInit {

  public showLoader: boolean = false;
  public errorMsg: string;
  public formErrors = {};
  public flagCount: number;
  ticket = FlagTicketCount;
  public flagTicket = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public _notificationsService: NotificationsService,
    private adminService: AdminService) {
  }

  public ngOnInit(): void {
    this.flagTicket['flag_count'] = 0;
    this.getFlagTicketCount();
  }

  public ngAfterViewInit(): void {

  }


  updateFlagTicketCount(){
    this.formErrors = {};
    let url = constants.URLs.updateFakeTicketCount;

    if (this.flagTicket['flag_count'] && this.flagTicket['flag_count'] != 0) {
      
    } else {
      this.formErrors['flag_count'] = 'This field is required';
      return false;
    }
    
    let model = {
      flag_count: this.flagTicket['flag_count'],
    };

    this.showLoader = true;
    this.adminService
      .approveRejectTicket(url, model, true)
      .then((res) => {
        this.showLoader = false;
        let msg = constants.messages.flagTicketCountUpdated;
        this.adminService.showSuccessToast(msg);
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
        }
      });
  }

  getFlagTicketCount(){
    let url = constants.URLs.getFakeTicketCount;

    this.showLoader = true;
    this.adminService
      .getCall(url, true)
      .then((res) => {
        this.showLoader = false;
        if( res && res.flag_count ){
          this.flagTicket['flag_count'] = res.flag_count;
        }
        // let msg = constants.messages.flagTicketCountUpdated;
        // this.adminService.showSuccessToast(msg);
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
        }
      });
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/flag-ticket-treshold-count/flag-ticket-treshold-count.component.ts